var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container homebase-container pt-5 pb-5" },
    [
      _c("div", { staticClass: "pb-4" }, [
        _c("div", [_c("back-to-home-button")], 1)
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.isLoading
        ? _c("loading-overlay")
        : _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 " }, [
                _vm.successMessage
                  ? _c(
                      "div",
                      {
                        staticClass: "fade-in-out alert alert-success px-2 ml-2"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "ml-1 d-inline justify-content-start"
                          },
                          [_vm._v(_vm._s(_vm.successMessage))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-inline justify-content-end" },
                          [
                            _c(
                              "div",
                              { staticClass: "close close-icon pr-2" },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "close-icon",
                                  attrs: { icon: "times", size: "xs" },
                                  on: { click: _vm.close }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _vm.isErrored
              ? _c("div", { staticClass: "alert alert-error" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.CONSTANTS.SERVER_ERROR_MESSAGE) +
                      "\n    "
                  )
                ])
              : _c("div", [
                  _c(
                    "div",
                    { staticClass: "table-wrapper mt-5" },
                    [
                      _c(
                        "vue-good-table",
                        {
                          staticClass: "table-word-wrap",
                          attrs: {
                            columns: _vm.columns,
                            rows: _vm.formattedRows,
                            "search-options": _vm.searchOptions,
                            "pagination-options": Object.assign(
                              {},
                              { enabled: this.paginationEnabled },
                              _vm.paginationOptions
                            ),
                            styleClass: "vgt-table striped"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "table-row",
                              fn: function(props) {
                                return [
                                  props.column.field === "actions"
                                    ? _c("span", [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "content row-content"
                                          },
                                          [
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "d-inline view-url",
                                                attrs: {
                                                  href: props.row.url,
                                                  target: _vm.getBookmarkTarget(
                                                    props.row.url
                                                  ),
                                                  rel: "noopener noreferrer"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.handleViewClick(
                                                      props.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  View\n                "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    : props.column.field == "title"
                                    ? _c("span", [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "AutodeskOneToggleBookmarkPage",
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  bookmarkRowValue: props.row
                                                },
                                                on: {
                                                  update: function($event) {
                                                    return _vm.onUpdateMessage(
                                                      $event
                                                    )
                                                  }
                                                }
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(props.row.title) +
                                                  "\n              "
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              }
                            },
                            {
                              key: "table-column",
                              fn: function(props) {
                                return [
                                  props.column.label == "Actions"
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(props.column.label) +
                                            "\n            "
                                        )
                                      ])
                                    : props.column.label === "Bookmark name"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(props.column.label) +
                                            "\n            "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(props.column.label) +
                                            "\n            "
                                        )
                                      ])
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _c(
                            "div",
                            {
                              attrs: { slot: "emptystate" },
                              slot: "emptystate"
                            },
                            [
                              _c("div", { staticClass: "emptystate-text" }, [
                                _vm._v("No bookmarks to display")
                              ])
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
          ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("h1", [_vm._v("Bookmarks")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c1f8e38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1f8e38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/pages/AutodeskOneBookmarksPage.vue
// module id = null
// module chunks = 